import { ObjectPicker, type ObjectPickerProps } from './ObjectPicker'

export interface StringPickerProps extends Omit<
  ObjectPickerProps<{ id: string; name: string }>,
  'search' | 'selected' | 'onChange' | 'renderMeta'
> {
  /** Runs on every (debounced) search term, including the empty one. */
  search: (term: string) => Promise<string[]>
  selected: string[]
  onChange: (selected: string[]) => void
}

/**
 * The same picker as {@link ObjectPicker}, for fields whose value is a list of
 * plain strings rather than object references — a label, a keyword, anything
 * the API searches by name and stores as the name itself.
 */
export function StringPicker({ search, selected, onChange, ...rest }: StringPickerProps) {
  return (
    <ObjectPicker
      {...rest}
      search={(term) => search(term).then((names) => names.map((name) => ({ id: name, name })))}
      selected={selected.map((name) => ({ id: name, name }))}
      onChange={(items) => onChange(items.map((item) => item.id))}
    />
  )
}
